function radioGroup() {
  let isChecked = false

  this.radioGroup.items.forEach(($radio) => {
    if ($radio.checked) {
      this.value = $radio.value
      isChecked = true
    }
  })

  if (!isChecked) {
    this.isValid = false
    return
  }

  this.isValid = true
}

export { radioGroup }
